import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuoteModal } from '../../../context/QuoteModalContext';

const SLIDES = [
  { src: '/assets/img/1fb6a28822d0.webp', alt: 'Pop Pro Tents stretch tent illuminated at a festival' },
  { src: '/assets/img/weddings-07.webp', alt: 'Aerial view of a wedding reception under Pop Pro stretch tents at golden hour' },
];

export default function Hero() {
  const [active, setActive] = useState(0);
  const { openModal } = useQuoteModal();

  useEffect(() => {
    const id = setInterval(() => setActive((prev) => (prev + 1) % SLIDES.length), 6000);
    return () => clearInterval(id);
  }, []);

  return (
    <section id="home" className="relative min-h-[calc(100vh+6rem)] flex items-center justify-center overflow-hidden pt-28 pb-16">
      {/* Background Image Carousel */}
      <div className="absolute inset-0">
        {SLIDES.map((slide, i) => (
          <img
            key={slide.src}
            src={slide.src}
            alt={slide.alt}
            className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-1000 ${i === active ? 'opacity-100' : 'opacity-0'}`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="space-y-6">
          <div className="flex justify-center mb-2">
            <img
              src="/assets/img/c27d79fc750c.webp"
              alt="Pop Pro Tents Sub Logo"
              className="w-32 md:w-40 object-contain drop-shadow-lg"
            />
          </div>
          <h1 className="text-xl md:text-2xl text-white/95 max-w-3xl mx-auto">
            Welcome to Pop Pro Tents®, your go-to creative studio specializing in custom stretch tent rentals.
          </h1>
          
          <div className="flex flex-wrap items-center justify-center gap-4 pt-6">
            <Link to="/products" className="bg-teal-400 hover:bg-teal-500 text-white px-8 py-4 rounded-lg text-base font-semibold transition-all transform hover:scale-105 whitespace-nowrap">
              EXPLORE PRODUCTS
            </Link>
            <button
              type="button"
              onClick={openModal}
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              BUY OR RENT
            </button>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-8 pt-12">
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg">
              <i className="ri-award-line text-3xl text-white"></i>
              <div className="text-left">
                <div className="text-2xl font-bold text-white">Largest</div>
                <div className="text-sm text-white/90">In the US</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg">
              <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                <img
                  src="/assets/img/f453b7a450bc.webp"
                  alt="ISO Certified"
                  className="w-7 h-7 object-contain"
                />
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-white">ISO</div>
                <div className="text-sm text-white/90">Certified Quality</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg">
              <i className="ri-shield-check-line text-3xl text-white"></i>
              <div className="text-left">
                <div className="text-2xl font-bold text-white">Quality Guarantee</div>
                <div className="text-sm text-white/90">Built to Last</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Carousel dots */}
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => setActive(i)}
            aria-label={`Show slide ${i + 1}`}
            className={`w-2.5 h-2.5 rounded-full transition-colors cursor-pointer ${i === active ? 'bg-white' : 'bg-white/40 hover:bg-white/60'}`}
          />
        ))}
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}